import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, Bell } from 'lucide-react';
import Logo from '../../assets/images/logo.png';
import ReferralModal from '../Modal/ReferralModal';
import MobileMenu from './MobileMenu';
import UserInfo from './UserInfo';
import Notification from '../Notification/Notification';
import SwitchAccount from 'src/components/ManageAccount/SwitchAccount';
import { useUserNotificationsQuery } from 'src/lib/endpoints/dashboard/dashboard.api';
import { pageTitleFor } from './navItems';

const Navbar = () => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showReferralModal, setShowReferralModal] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const { notifications } = useUserNotificationsQuery();
  const location = useLocation();

  const unread = notifications?.notReadCount ?? 0;

  return (
    <>
      <header className='sticky top-0 z-40 flex h-14 items-center justify-between gap-3 border-b bg-card px-4 shadow-ui-sm lg:px-8'>
        <div className='flex min-w-0 items-center gap-3'>
          <button
            type='button'
            onClick={() => setShowMobileMenu(true)}
            aria-label='Open menu'
            className='-ml-2 rounded-full p-2 text-brand-navy hover:bg-surface lg:hidden'
          >
            <Menu className='h-5 w-5' />
          </button>
          <img
            src={Logo}
            alt=''
            aria-hidden='true'
            className='h-7 w-7 shrink-0 lg:hidden'
          />
          <div className='truncate text-sm font-bold text-brand-navy sm:text-base'>
            {pageTitleFor(location.pathname)}
          </div>
        </div>

        <div className='flex shrink-0 items-center gap-2'>
          {/* Account switcher hidden on Marketplace pages: the Manage account
              (payroll, invoices, tax) is not offered to talents yet, and this
              was the only way in. It stays on /manage pages because the
              Manage sidebar has no link back, so it is the only way out. To
              hide it everywhere, drop the line; to restore it, drop the
              condition. */}
          {location.pathname.startsWith('/manage') && <SwitchAccount />}

          {/* Refer & Earn hidden for now; restore by uncommenting. */}
          {/* <button type='button' onClick={() => setShowReferralModal(true)} className='hidden h-9 items-center rounded-lg border border-brand-navy px-4 text-sm font-semibold text-brand-navy transition-colors hover:bg-surface lg:inline-flex' > Refer &amp; Earn </button> */}

          <button
            type='button'
            onClick={() => setShowNotification((o) => !o)}
            aria-label='Notifications'
            className='relative rounded-full p-2 text-brand-navy hover:bg-surface'
          >
            <Bell className='h-5 w-5' />
            {!!unread && (
              <span className='absolute -right-0.5 -top-0.5 grid h-4 min-w-4 place-items-center rounded-full bg-brand-orange px-1 text-[9px] font-bold tabular-nums text-white'>
                {unread > 99 ? '99+' : unread}
              </span>
            )}
          </button>

          <Link to='/profile' className='rounded-full'>
            <UserInfo />
          </Link>
        </div>
      </header>

      <ReferralModal
        open={showReferralModal}
        closeModal={() => setShowReferralModal(false)}
      />

      {showNotification && (
        <Notification
          open={showNotification}
          callback={() => setShowNotification(false)}
        />
      )}

      <MobileMenu
        showMobileMenu={showMobileMenu}
        setShowMobileMenu={setShowMobileMenu}
      />
    </>
  );
};

export default Navbar;